/* RESPONSIBLE TEAM: team-tickets-1 */
import Model, { attr } from '@ember-data/model';

export default class CancellationQuestionResponse extends Model {
  @attr() appId;
  @attr() adminId;
  @attr('array') reasonIds;
  @attr() comment;
}
